export default __webpack_public_path__ + "static/media/cybersource.36b2077a.png";